import { create, el } from "@dhx/ts-common/dom";
import { View } from "@dhx/ts-common/view";
import locale from "./locales/en";

import { IProgressBarConfig, IVaultEventSystem, ProgressBarEvents } from "./types";

export class ProgressBar<T> extends View {
	public config: IProgressBarConfig<T>;
	public events: IVaultEventSystem;

	private _progress: number;
	private _progressText: string;

	private _abortUpload;

	constructor(events: IVaultEventSystem, config: IProgressBarConfig<T>) {
		super(null, config);

		this.events = events;

		this._progress = 0;

		const render = () => this._draw();
		this.mount(
			null,
			create({
				render,
			})
		);

		this._abortUpload = () => {
			this.events.fire(ProgressBarEvents.cancel);
		};
	}

	setState(progress: number, extra: T) {
		this._progress = progress;
		if (this.config.template) {
			this._progressText = this.config.template(progress, extra);
		} else {
			this._progressText = this._progress.toFixed(1) + "%";
		}
		this.paint();
	}

	private _draw() {
		return el(
			".progress-bar",
			{
				_key: this._uid,
			},
			[
				el(".progress-indicator", {
					style: {
						width: this._progress + "%",
					},
				}),
				el(".progress-text", {
					".innerHTML": this._progressText,
				}),
				el(
					"button",
					{
						class: "dhx_btn dhx_btn--flat dhx_btn_small action-abort-all",
						onclick: this._abortUpload,
					},
					locale.cancel
				),
			]
		);
	}
}
